// extracted by mini-css-extract-plugin
module.exports = {"commentUi":"Comment_commentUi__cB8d2","commentUiArrowIcon":"Comment_commentUiArrowIcon__4wDEl","commentUiOpen":"Comment_commentUiOpen__3nLuV","summary":"Comment_summary__1Bs7u"};